import { trackWarn } from '../tracking/warns';

/**
 * Tracks custom New Relic javascript errors without disrupting operations
 *
 * @param {Error} error Error object
 * @param {String} message More detailed error message
 * @param {Object} args Optional additional arguments
 * @returns
 */
const trackCartError = (error, message, args = {}) => {
  const details = {
    action: 'External cart error',
    message,
    ...args
  };
  trackWarn('external-cart', details);

  if (!window.newrelic) return;
  window.newrelic.noticeError(error, { customAttributes: details });
};

export default trackCartError;
